import { carouselHubElement } from '../../carousel/carouselHubElement';
import { linkCardsHubElement } from '../../link-cards/linkCardsHubElement';
import { spotlightHubElement } from '../../spotlight/spotlightHubElement';

import type { HubElement } from './hubElementType';

export const getSortedHubElements = (): HubElement[] => {
	const hubElements = [spotlightHubElement, linkCardsHubElement, carouselHubElement];
	return hubElements.sort((a, b) =>
		(a.title.defaultMessage ?? '') > (b.title.defaultMessage ?? '') ? 1 : -1,
	);
};

export const getPlaceholderHubElements = (): HubElement[] => {
	return [spotlightHubElement, linkCardsHubElement, carouselHubElement];
};
